import { render } from "./free-gift-promo.vue?vue&type=template&id=42fe566b"
import script from "./free-gift-promo.vue?vue&type=script&lang=js"
export * from "./free-gift-promo.vue?vue&type=script&lang=js"

import exportComponent from "/Users/emilyyork/Shopify/clients/sneak-fr1/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__